import {Page} from "../page";
import { FeedbackHelp } from "./feedbackHelp";

let template = require('./feedback.twig');

export class Feedback extends Page
{
    constructor() {
        super();
        this.feedback_id = 0;
        const modalValue = app.appData.configs?.SHOW_CATEGORY_DESCRIPTION_MODAL;
        this.showCategoryModal = modalValue === true || modalValue === "true";
        this.dom = $(twig({ data: template }).render({'showCategoryModal': this.showCategoryModal}))

        let category_dd = this.dom.find('[name=feedback_category]');
        let meeting_id_input = this.dom.find('[name=meeting_id]');
        let meeting_label = this.dom.find('label[for="meeting_id"]');

        Object.values(app.appData.feedbackCategories).forEach(
            category => category_dd.append('<option value="' + category.category_id + '">' + category.name + '</option>'));

        this.feedbackHelp = new FeedbackHelp();

        this.dom.find('.help-icon').on('click mouseenter', (e) => {
            e.preventDefault();
            this.feedbackHelp.show();
        });

        category_dd.on('change', () => {
            let category_id = category_dd.val();
            Object.values(app.appData.feedbackCategories).forEach(category => {
                if (category.category_id == category_id) {
                    if (category.meeting_related == 1) {
                        meeting_id_input.attr('required', 'required').addClass('feedback required is-invalid');
                        if (!meeting_label.find('span').length) {
                            meeting_label.append(" <span style='color:red'>*</span>");
                        }
                    } else {
                        meeting_id_input.removeAttr('required').val('').removeClass('feedback required is-invalid');
                        meeting_label.find('span').remove();
                    }
                }
            });
        });

        this.dom.on('input change', 'input.feedback, textarea.feedback, select.feedback', (event) => {
            const $el = $(event.target);

            $el.toggleClass(
                'required is-invalid',
                $el.val() === null || $el.val().toString().trim() === ''
            );
        });

        this.dom.find('[type=reset]').on('click', () => {
            this.dom.find('input, select, textarea').val('').addClass('feedback');
            this.dropzone.removeAllFiles();
            let meeting_label = this.dom.find('label[for="meeting_id"]');
            if (!meeting_label.find('span').length) {
                meeting_label.append(" <span style='color:red'>*</span>");
            }
            this.dom.find('.feedback').trigger('change');
        })

        this.dom.find('form').on('submit', async (event) => {
            event.preventDefault();

            try {
                // Step 1: Submit feedback (synchronously)
                const feedbackResponse = await $.ajax({
                    url: 'api/feedback',
                    type: 'post',
                    data: {
                        feedback_category: this.dom.find('[name=feedback_category]').val(),
                        feedback_text: this.dom.find('[name=feedback_text]').val(),
                        meeting_id: this.dom.find('[name=meeting_id]').val(),
                    }
                });

                // Step 2: Show the notification after feedback submission
                displayNotification({
                    title: feedbackResponse.success ? 'Feedback Submitted!' : 'Something went wrong',
                    success: feedbackResponse.success
                });

                // Save feedback_id for further use (file uploads and email)
                this.feedback_id = feedbackResponse.feedback_id;

                // Step 3: If Dropzone is available, handle file uploads (if any)
                if (this.dropzone && this.dropzone.getQueuedFiles().length > 0) {
                    this.dropzone.options.url = $('base').attr('href') + 'api/feedback/' + this.feedback_id + '/files';

                    // Process the queue and wait until all files are uploaded
                    await new Promise((resolve, reject) => {
                        this.dropzone.on('queuecomplete', resolve); // Resolve the promise once the queue is complete
                        this.dropzone.on('error', reject); // Reject the promise if there is an error
                        this.dropzone.processQueue();
                    });

                    // Optionally remove all files after the upload completes
                    this.dropzone.removeAllFiles();
                }

                // Step 4: Always trigger the email (even if no files were uploaded)
                if (app.appData.configs.SEND_FEEDBACK_EMAIL ?? false) {
                    await this.triggerEmail();
                }
                
                // Step 5: Reset the form after everything is done
                this.dom.find('[type=reset]').trigger('click');
            } catch (error) {
                displayNotification({
                    title: 'Something went wrong',
                    message: error.message || 'Please try again later.',
                    success: false
                });
            }
        });
    }

    async triggerEmail() {
        try {
            const emailResponse = await $.ajax({
                url: 'api/feedback/sendEmail',
                type: 'post',
                data: {
                    feedback_id: this.feedback_id
                }
            });

            displayNotification({
                title: emailResponse.success ? 'Email Sent!' : 'Something went wrong',
                success: emailResponse.success
            });
        } catch (error) {
            displayNotification({
                title: 'Email Send Failed',
                message: 'There was an error sending the email. Please try again later.',
                success: false
            });
        }
    }

    ready() {
        if(typeof this.dropzone == 'undefined') {
            this.dropzone = new Dropzone('#drop_zone', {
                url: '/fake/path',
                autoQueue: true,
                autoProcessQueue: false,
                parallelUploads: 10
            })

            this.dropzone.on("addedfile", (file) => {
                file.previewElement.addEventListener("click", () => {
                    this.dropzone.removeFile(file);
                });
            });
        }
    }
}